export default ({ axios, mapQueryString }) => ({
    index: (filters = {}) => axios.get(`/api/holidays${mapQueryString(filters)}`).then(({ data }) => data),
    show: (id, query = {}) => axios.get(`/api/holidays/${id}${mapQueryString(query)}`).then(({ data }) => data),
    store: (body) => axios.post(`/api/holidays`, body).then(({ data }) => data),
    update: (id, body) => axios.patch(`/api/holidays/${id}`, body).then(({ data }) => data),
    delete: (id) => axios.delete(`/api/holidays/${id}`).then(({ data }) => data)
})